import { z } from 'zod/v4';

export type SortOrder = 'asc' | 'desc';

export const uuid = z.uuid({ version: 'v4' });

export const externalId = z.string().nullish();

export const createdByUserId = {
  createdByUserId: z.uuid(),
};

export const createdByUserUuid = {
  createdByUserUuid: z.uuid(),
};

export const nullableCreatedByUserUuid = {
  createdByUserUuid: z.uuid().nullish(),
};

export const createdByServiceUuid = {
  createdByServiceUuid: z.uuid().nullish(),
};

export const createdById = {
  createdById: z.string().nullish(),
};

export const createdByTeamUuid = {
  createdByTeamUuid: z.uuid(),
};

export const timestamps = {
  createdAt: z.date(),
  updatedAt: z.date(),
};

export const softDelete = {
  deletedByUserUuid: z.uuid().nullish(),
  deletedAt: z.date().nullish(),
};

export const notSoftDeletedWhereFilter = {
  deletedAt: null,
};
